export class HistoryConst {
  static displayColumns = () => {
    return [
      {
        title: 'ID cuộc gọi',
        key: 'callId',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Nguồn',
        key: 'callType',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
      {
        title: 'Đầu số',
        key: 'called',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Hàng đợi',
        key: 'queueId',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Chiến dịch',
        key: 'campaignId',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Chuyên viên',
        key: 'agentId',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Số khách hàng',
        key: 'display_caller',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Thời điểm bắt đầu',
        key: 'startTime',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Thời điểm đổ chuông',
        key: 'ringTime',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Thời điểm nhấc máy',
        key: 'connectTime',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Thời gian chờ',
        key: 'waitingTime',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
      {
        title: 'Thời gian đàm thoại',
        key: 'acdTime',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
      {
        title: 'Thời điểm kết thúc',
        key: 'endTime',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Thời lượng cuộc gọi',
        key: 'duration',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
      {
        title: 'Trạng thái',
        key: 'display_status',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
      {
        title: 'File ghi âm',
        key: 'display_url',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
    ];
  };

  static displayColumnsExport = () => {
    return [
      {
        title: 'ID cuộc gọi',
        key: 'callId',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Nguồn',
        key: 'callType',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
      {
        title: 'Đầu số',
        key: 'called',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Hàng đợi',
        key: 'queueId',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Chiến dịch',
        key: 'campaignId',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Chuyên viên',
        key: 'agentId',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Số khách hàng',
        key: 'caller',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Thời điểm bắt đầu',
        key: 'startTime',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Thời điểm đổ chuông',
        key: 'ringTime',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Thời điểm nhấc máy',
        key: 'connectTime',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Thời gian chờ',
        key: 'waitingTime',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
      {
        title: 'Thời gian đàm thoại',
        key: 'acdTime',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
      {
        title: 'Thời điểm kết thúc',
        key: 'endTime',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Thời lượng cuộc gọi',
        key: 'duration',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
      {
        title: 'Trạng thái',
        key: 'display_status_export',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
    ];
  };
  static callType = callType => {
    return callType == 1 ? 'OUTBOUND' : 'INBOUND';
  };
  static displayAgentColumn = (item, agents) => {
    const agents_in_call = item.agentId ? item.agentId.split(',') : [];
    if (agents_in_call.length > 0) {
      let text = '';
      let i = 0;
      agents_in_call.forEach(res => {
        const a = agents.find(a => a.id == res || a.email == res);
        if (a) {
          text += a.text + (i < agents_in_call.length - 1 ? ' - ' : '');
        }

        i++;
      });
      return text ? text : 'Không xác định';
    } else {
      return 'Không xác định';
    }
  };
  static displayQueueColumn = (item, agents) => {
    const a = agents.find(a => a.id == item.queueId);
    return a ? a.text : 'Không xác định';
  };
  static displayFileUrlColumn = status => {
    if (status) {
      return `<a class="mx-5 text-success" href="javascript:void(0)">
                <i class="icon fa fa-play"></i>
              </a>`;
    } else {
      return '';
    }
  };
  static displayStatusColumn = status => {
    if (status) {
      return `<span class="text-success">Đã trả lời</span>`;
    } else {
      return `<span class="text-danger">Bị nhỡ</span>`;
    }
  };

  static displayStatusExportColumn = status => {
    if (status) {
      return `Đã trả lời`;
    } else {
      return `Bị nhỡ`;
    }
  };
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/reportv2/history/history.const.ts